<template>
  <v-app-bar app :elevation="0" color="bgWhite" dense class="py-4 px-4" style="min-height: 70px;">
    <v-app-bar-nav-icon v-if="!sideBar" @click.stop="setSideBar(!sideBar)" />
    <v-spacer></v-spacer>

    <div class="mt-5 d-flex align-center mb-5 navbar-container">
      <div class="self-end">
        <div
          class="font-weight-bold bluePrimary--text d-none d-sm-block"
          style="line-height: 0.8"
        >
          {{ getFullName?.toUpperCase() || "Invitado" }}
        </div>
        
      </div>
      <v-icon size="40" color="#1c1e4d">mdi-account-circle</v-icon>
      <v-icon size="20" color="#1c1e4d" @click="cerrarSession()">mdi-logout</v-icon>
      <span
        @click="cerrarSession()"
        class="text-decoration-underline d-none d-sm-block"
        style="cursor: pointer; color: #1c1e4d"
      >
        Cerrar sesión
      </span>
    </div>
  </v-app-bar>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "AppHeader",
  data() {
    return {
      perfiles: []
    }
  },
  methods: {
    ...mapMutations("utils", ["setSideBar", "setMenu"]),
    ...mapMutations(["setToken"]),

     async cerrarSession() {
      if(this.isTokenValido(this.token)) {
        this.setMenu([]);
        //this.setToken(null);
        await this.services.auth.logout()
        localStorage.clear();
        this.$router.push({name: 'login'}).catch((e) => {
        });

      } else {
        this.temporalAlert({
          show:true,
          type:"error",
          message:"El token ya expiró, debe de volver a iniciar sesión"
        })
        this.$router.replace({name: "login"})
      }
     },
     verificarPerfiles() {
      const userToken = localStorage.getItem("token");
      const userDecode = jwtDecode(userToken);
      let perfiles = userDecode.puesto?.perfiles;
      
      this.perfiles = perfiles;
    },
    created() {
      this.verificarPerfiles()
    },
  },
  computed: {
    ...mapState(["userInfo", "token"]),
    ...mapState("utils", {
      sideBar: "sideBar",
    }),
    getFullName() {
      const { nombres, apellidos } = this.userInfo || {};

      // Extrae el primer nombre y el primer apellido
      const primerNombre = nombres ? nombres.split(" ")[0] : "";
      const primerApellido = apellidos ? apellidos.split(" ")[0] : "";

      return `${primerNombre} ${primerApellido}`.trim();
    },
    getPerfil() {
      let perfiles = this.perfiles || [];
      if (Array.isArray(perfiles) && perfiles.length == 1) {
        return perfiles.map((perfil) => perfil.nombre).join(", ");
      }
      return "";
    },
  },
};
</script>

<style scoped>
.navbar-container {
  gap: 0.5rem;
}
</style>